module.exports = __webpack_public_path__ + "static/media/crutches.c6a51bb3.svg";